import { render, staticRenderFns } from "./ItemsForm.vue?vue&type=template&id=21026d35&"
import script from "./ItemsForm.vue?vue&type=script&lang=js&"
export * from "./ItemsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports